import { getTrackRole, } from "@gearbox-protocol/liquidator-v2-config";
export function collapseKey(creditManager, creditAccount) {
    return [creditManager, creditAccount].filter(Boolean).join(":").toLowerCase();
}
/**
 * Returns id of the first visible track of the role, or of the role's first track if none is visible
 */
export function firstTrackOfRole(tracks, role, trackFilters) {
    const roleTracks = tracks.filter(t => getTrackRole(t) === role);
    return (roleTracks.find(t => !!trackFilters[t.id]) ?? roleTracks[0])?.id;
}
